import React, { ReactNode } from 'react';

import { Container } from '@infoods/lifebase-ui';

import classes from './AuthPageLayout.module.scss';
import { SwymoHeader } from '../../../shared/components/header-components/SwymoHeader/SwymoHeader';

type AuthPageLayoutProps = {
  children: ReactNode;
};

/**
 * Full-bleed auth page shell: background + header.
 * Breaks out of md-content.app-container horizontal padding via negative margins.
 */
const AuthPageLayout = ({ children }: AuthPageLayoutProps) => {
  return (
    <div className={classes.root}>
      <SwymoHeader variant="dark" />
      <Container className={classes.container}>{children}</Container>
    </div>
  );
};

export { AuthPageLayout };
